import { BoardDTO } from './entity-model/board.model';
import { MemberDTO } from './entity-model/member.model';
import { TaskAssigneeDTO } from './entity-model/task-assignee.model';
import { TaskLabelDTO } from './entity-model/task-label.model';
import { TaskListDTO } from './entity-model/task-list.model';
import { TaskReminderDTO } from './entity-model/task-reminder.model';
import { TaskDTO } from './entity-model/task.model';
import { WorkspaceLabelDTO } from './entity-model/workspace-label.model';

export enum TaskWebsocketEventType {
  CREATE = 'noteTask:create',
  UPDATE = 'noteTask:update',
  REMOVE = 'noteTask:remove',
}

export enum TaskListWebsocketEventType {
  CREATE = 'noteTaskList:create',
  UPDATE = 'noteTaskList:update',
  REMOVE = 'noteTaskList:remove',
  RESTORE = 'noteTaskList:restore',
}

export enum TaskAssigneeWebsocketEventType {
  CREATE = 'noteTask:assigneeCreate',
  REMOVE = 'noteTask:assigneeRemove',
}

export enum TaskLabelWebsocketEventType {
  CREATE = 'noteTask:labelCreate',
  REMOVE = 'noteTask:labelRemove',
}

export enum WorkspaceLabelWebsocketEventType {
  CREATE = 'workspaceLabel:create',
  UPDATE = 'workspaceLabel:update',
  REMOVE = 'workspaceLabel:remove',
}

export enum TaskReminderWebsocketEventType {
  CREATE = 'noteTask:reminderCreate',
  UPDATE = 'noteTask:reminderUpdate',
  REMOVE = 'noteTask:reminderRemove',
}

export enum WorkspaceMemberWebsocketEventType {
  UPDATE = 'workspaceMember:update',
  REMOVE = 'workspaceMember:remove',
}

export enum TaskBoardWebsocketEventType {
  CHANGE = 'board:change',
}

export type WorkspaceTasksWebsocketEventType =
  | TaskListWebsocketEventType
  | TaskWebsocketEventType
  | TaskAssigneeWebsocketEventType
  | TaskLabelWebsocketEventType
  | TaskReminderWebsocketEventType
  | WorkspaceLabelWebsocketEventType
  | WorkspaceMemberWebsocketEventType
  | TaskBoardWebsocketEventType;

export const workspaceTasksWebsocketEventTypes: WorkspaceTasksWebsocketEventType[] = [
  ...Object.values(TaskWebsocketEventType),
  ...Object.values(TaskListWebsocketEventType),
  ...Object.values(TaskAssigneeWebsocketEventType),
  ...Object.values(TaskLabelWebsocketEventType),
  ...Object.values(TaskReminderWebsocketEventType),
  ...Object.values(WorkspaceLabelWebsocketEventType),
  ...Object.values(WorkspaceMemberWebsocketEventType),
  ...Object.values(TaskBoardWebsocketEventType),
];

export interface WebsocketGenericMessage<K, V> {
  eventName: K;
  payload: {
    message: WebsocketEventMessage<V>;
    workspaceId: string;
  };
}

export interface WebsocketEventMessage<V> {
  globalId: string;
  workspaceId: string;
  isCreate?: boolean;
  tasksIds?: string[];
  after: V | null;
  before: V | null;
}

export type TaskWebsocketEvent =
  | WebsocketGenericMessage<TaskWebsocketEventType.CREATE, TaskDTO>
  | WebsocketGenericMessage<TaskWebsocketEventType.UPDATE, TaskDTO>
  | WebsocketGenericMessage<TaskWebsocketEventType.REMOVE, TaskDTO>;

export type TaskListWebsocketEvent =
  | WebsocketGenericMessage<TaskListWebsocketEventType.CREATE, TaskListDTO>
  | WebsocketGenericMessage<TaskListWebsocketEventType.UPDATE, TaskListDTO>
  | WebsocketGenericMessage<TaskListWebsocketEventType.REMOVE, TaskListDTO>;

export type TaskAssigneeWebsocketEvent =
  | WebsocketGenericMessage<TaskAssigneeWebsocketEventType.CREATE, TaskAssigneeDTO>
  | WebsocketGenericMessage<TaskAssigneeWebsocketEventType.REMOVE, TaskAssigneeDTO>;

export type TaskLabelWebsocketEvent =
  | WebsocketGenericMessage<TaskLabelWebsocketEventType.CREATE, TaskLabelDTO>
  | WebsocketGenericMessage<TaskLabelWebsocketEventType.REMOVE, TaskLabelDTO>;

export type WorkspaceLabelWebsocketEvent =
  | WebsocketGenericMessage<WorkspaceLabelWebsocketEventType.CREATE, WorkspaceLabelDTO>
  | WebsocketGenericMessage<WorkspaceLabelWebsocketEventType.UPDATE, WorkspaceLabelDTO>
  | WebsocketGenericMessage<WorkspaceLabelWebsocketEventType.REMOVE, WorkspaceLabelDTO>;

export type TaskReminderWebsocketEvent =
  | WebsocketGenericMessage<TaskReminderWebsocketEventType.CREATE, TaskReminderDTO>
  | WebsocketGenericMessage<TaskReminderWebsocketEventType.UPDATE, TaskReminderDTO>
  | WebsocketGenericMessage<TaskReminderWebsocketEventType.REMOVE, TaskReminderDTO>;

export type WorkspaceMembersWebsocketEvent = WebsocketGenericMessage<
  WorkspaceMemberWebsocketEventType.UPDATE,
  MemberDTO
>;

export type TaskBoardWebsocketEvent = WebsocketGenericMessage<TaskBoardWebsocketEventType.CHANGE, BoardDTO>;

export type FeatureWebsocketEvent =
  | TaskWebsocketEvent
  | TaskListWebsocketEvent
  | TaskAssigneeWebsocketEvent
  | TaskLabelWebsocketEvent
  | TaskReminderWebsocketEvent
  | WorkspaceLabelWebsocketEvent
  | WorkspaceMembersWebsocketEvent
  | TaskBoardWebsocketEvent;
